export default __webpack_public_path__ + "static/media/outdoor_store_sign_reduced.fbf3b133.jpg";